import { useEffect } from 'react';

/**
 * 自定義 Hook 用於設置頁面標題
 * @param {string} title - 頁面標題
 * @param {string} suffix - 標題後綴，預設為 "天藍小舖"
 * @param {string} description - 頁面描述（可選）
 */
export const usePageTitle = (title, suffix = '天藍小舖', description = null) => {
  useEffect(() => {
    const fullTitle = title ? `${title} - ${suffix}` : suffix;
    document.title = fullTitle;
    
    // 同時更新 meta 標籤
    const metaTitle = document.querySelector('meta[property="og:title"]');
    const metaTwitterTitle = document.querySelector('meta[name="twitter:title"]');
    const metaDescription = document.querySelector('meta[name="description"]');
    const metaOgDescription = document.querySelector('meta[property="og:description"]');
    const metaTwitterDescription = document.querySelector('meta[name="twitter:description"]');
    
    if (metaTitle) {
      metaTitle.setAttribute('content', fullTitle);
    }
    if (metaTwitterTitle) {
      metaTwitterTitle.setAttribute('content', fullTitle);
    }
    
    // 如果有提供描述，更新描述標籤
    if (description) {
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
      if (metaOgDescription) {
        metaOgDescription.setAttribute('content', description);
      }
      if (metaTwitterDescription) {
        metaTwitterDescription.setAttribute('content', description);
      }
    }
    
    // 清理函數：當組件卸載時恢復原始標題
    return () => {
      document.title = '天藍小舖 - 直播換貨查詢';
      if (metaTitle) {
        metaTitle.setAttribute('content', '天藍小舖 - 直播換貨查詢');
      }
      if (metaTwitterTitle) {
        metaTwitterTitle.setAttribute('content', '天藍小舖 - 直播換貨查詢');
      }
      if (metaDescription) {
        metaDescription.setAttribute('content', '天藍小舖直播換貨服務，輸入PA單號或電話號碼即可查詢和申請換貨');
      }
      if (metaOgDescription) {
        metaOgDescription.setAttribute('content', '天藍小舖直播換貨服務，輸入PA單號或電話號碼即可查詢和申請換貨');
      }
      if (metaTwitterDescription) {
        metaTwitterDescription.setAttribute('content', '天藍小舖直播換貨服務，輸入PA單號或電話號碼即可查詢和申請換貨');
      }
    };
  }, [title, suffix, description]);
};

export default usePageTitle;
